import axios from 'axios'
import qs from 'qs'
import { LOADING_STARTS, LOADING_STOPS } from '../../../services/types/LoadingTypes'
import { REGISTER_URL } from '../../../services/apis/SignUpUrl'
import { toast } from 'react-toastify'
import { PAYSTACK_PUBLIC_KEY, GENIATECH_URL, VERIFICATION_URL } from '../../../services/config'
import { SCHEDULE_SUCCESS } from '../../../services/types/SchedulerTypes'
import { CHECK_AVAILABLE_DATES_URL } from '../../../services/apis/SchedulerUrl'
import scheduleReducer from '../../reducers/schedule/scheduleReducer'
import { useEffect, useReducer } from 'react'

export const signUp = (data, amount, history) => async (dispatch) => {
  dispatch({
    type: LOADING_STARTS,
    payload: true,
  })

  const email = data.email
  const phone = data.phoneNumber
  const lastname = data.lastName
  const address = data.address2
  const firstName = data.firstName
  const Swal = require('sweetalert2')

  try {
    const response = await axios.post(`${REGISTER_URL}`, data)
    if (response.data.id) {
      dispatch({
        type: LOADING_STOPS,
        payload: false,
      })
      const userid = response.data.id
      const newuser = response.data
      const zoneid = response.data.zone_id
      const payment_option = data.payment_option
      const state = data.state
      const generated_reference = Math.floor(Math.random() * 1000000000 + 1)

      //("/login")
      switch (amount) {
        case 17500:
          if (
            state === 'Abia' ||
            state === 'Kano' ||
            state === 'Delta' ||
            state === 'Akwa-ibom' ||
            state === 'Anambra' ||
            state === 'Kaduna' ||
            state === 'Imo' ||
            state === 'Enugu' ||
            state === 'Cross river' ||
            state === 'Oyo' ||
            state === 'Ogun' ||
            state === 'Edo'
          ) {
            //   try{
            let ServiceHandler
            ServiceHandler = window.PaystackPop.setup({
              key: `${PAYSTACK_PUBLIC_KEY}`,
              email: email,
              amount: 16750000,
              ref: '' + generated_reference, // generates a pseudo-unique reference. Please replace with a reference you generated. Or remove the line entirely so our API will generate one for you
              firstname: firstName,
              lastname: lastname,
              // label: "Optional string that replaces user email"
              metadata: {
                custom_fields: [
                  {
                    email: email,
                    state: state,
                    payment_type: 'installation',
                    month: '1',
                    amount: 167500,
                    firstname: firstName,
                    lastname: lastname,
                    phone: phone,
                  },
                ],
              },
              callback: function (response) {
                if (response.reference && response.status === 'success') {
                  const ref = response.reference

                  try {
                    axios.get(`${VERIFICATION_URL}${ref}`, {}).then((res) => {
                      if (res.data.data.status === 'success' && res.data.data.domain === 'live') {
                        toast.success('Transaction successful')
                        // setTimeout(() => {
                        //   history.push({
                        //     pathname: '/scheduler',
                        //     state: {
                        //       detail: newuser,
                        //       user_id: userid,
                        //       zone_id: zoneid,
                        //       address: address,
                        //       reference: ref,
                        //       category: 1,
                        //     },
                        //   })
                        // })
                      } else {
                        toast.info('Something went wrong!')
                      }
                    })
                  } catch (e) {
                    toast.info('Something went wrong!')
                  }
                } else {
                  toast.info('Transaction Failed')
                }
              },
              onClose: function () {
                //            alert('window closed');
              },
            })
            ServiceHandler.openIframe()
          } else if (state === 'Abuja' || state === 'Lagos' || state === 'Rivers') {
            //   try{
            let ServiceHandler
            ServiceHandler = window.PaystackPop.setup({
              key: `${PAYSTACK_PUBLIC_KEY}`,
              email: email,
              amount: 17250000,
              ref: '' + generated_reference, // generates a pseudo-unique reference. Please replace with a reference you generated. Or remove the line entirely so our API will generate one for you
              firstname: firstName,
              lastname: lastname,
              // label: "Optional string that replaces user email"
              metadata: {
                custom_fields: [
                  {
                    email: email,
                    amount: 172500,
                    state: state,
                    payment_type: 'installation',
                    month: '1',
                    firstname: firstName,
                    lastname: lastname,
                    phone: phone,
                  },
                ],
              },
              callback: function (response) {
                if (response.reference && response.status === 'success') {
                  const ref = response.reference

                  try {
                    axios.get(`${VERIFICATION_URL}${ref}`, {}).then((res) => {
                      if (res.data.data.status === 'success' && res.data.data.domain === 'live') {
                        toast.success('Transaction successful')
                        // setTimeout(() => {
                        //   history.push({
                        //     pathname: '/scheduler',
                        //     state: {
                        //       detail: newuser,
                        //       user_id: userid,
                        //       zone_id: zoneid,
                        //       address: address,
                        //       reference: ref,
                        //       category: 1,
                        //     },
                        //   })
                        // })
                      } else {
                        toast.info('Something went wrong!')
                      }
                    })
                  } catch (e) {
                    toast.info('Something went wrong!')
                  }
                } else {
                  toast.info('Transaction Failed')
                }
              },
              onClose: function () {
                //            alert('window closed');
              },
            })
            ServiceHandler.openIframe()
          } else if (
            state === 'Sokoto' ||
            state === 'Kebbi' ||
            state === 'Zamfara' ||
            state === 'Niger' ||
            state === 'Kwara' ||
            state === 'Osun' ||
            state === 'Ekiti' ||
            state === 'Ondo' ||
            state === 'Kogi' ||
            state === 'Bayelsa' ||
            state === 'Katsina' ||
            state === 'Bauchi' ||
            state === 'Nasarawa' ||
            state === 'Benue' ||
            state === 'Ebonyi' ||
            state === 'Jigawa' ||
            state === 'Yobe' ||
            state === 'Borno' ||
            state === 'Gombe' ||
            state === 'Adamawa' ||
            state === 'Plateau' ||
            state === 'Taraba'
          ) {
            let ServiceHandler
            ServiceHandler = window.PaystackPop.setup({
              key: `${PAYSTACK_PUBLIC_KEY}`,
              email: email,
              amount: 17500000,
              ref: '' + generated_reference, // generates a pseudo-unique reference. Please replace with a reference you generated. Or remove the line entirely so our API will generate one for you
              firstname: firstName,
              lastname: lastname,
              // label: "Optional string that replaces user email"
              metadata: {
                custom_fields: [
                  {
                    email: email,
                    amount: 175000,
                    state: state,
                    payment_type: 'installation',
                    month: '1',
                    firstname: firstName,
                    lastname: lastname,
                    phone: phone,
                  },
                ],
              },
              callback: function (response) {
                if (response.reference && response.status === 'success') {
                  const ref = response.reference

                  try {
                    axios.get(`${VERIFICATION_URL}${ref}`, {}).then((res) => {
                      if (res.data.data.status === 'success' && res.data.data.domain === 'live') {
                        toast.success('Transaction successful')
                        // setTimeout(() => {
                        //   history.push({
                        //     pathname: '/scheduler',
                        //     state: {
                        //       detail: newuser,
                        //       user_id: userid,
                        //       zone_id: zoneid,
                        //       address: address,
                        //       reference: ref,
                        //       category: 1,
                        //     },
                        //   })
                        // })
                      } else {
                        toast.info('Something went wrong!')
                      }
                    })
                  } catch (e) {
                    toast.info('Something went wrong!')
                  }
                } else {
                  toast.info('Transaction Failed')
                }
              },
              onClose: function () {
                //            alert('window closed');
              },
            })
            ServiceHandler.openIframe()
          }

          break

        case 105000:
          if (
            state === 'Abia' ||
            state === 'Kano' ||
            state === 'Delta' ||
            state === 'Akwa-ibom' ||
            state === 'Anambra' ||
            state === 'Kaduna' ||
            state === 'Imo' ||
            state === 'Enugu' ||
            state === 'Cross river' ||
            state === 'Oyo' ||
            state === 'Ogun' ||
            state === 'Edo'
          ) {
            //   try{
            let ResidentialProHandler
            ResidentialProHandler = window.PaystackPop.setup({
              key: `${PAYSTACK_PUBLIC_KEY}`,
              email: email,
              amount: 25500000,
              ref: '' + generated_reference, // generates a pseudo-unique reference. Please replace with a reference you generated. Or remove the line entirely so our API will generate one for you
              firstname: firstName,
              lastname: lastname,
              // label: "Optional string that replaces user email"
              metadata: {
                custom_fields: [
                  {
                    email: email,
                    amount: 255000,
                    state: state,
                    payment_type: 'installation',
                    month: '6',
                    firstname: firstName,
                    lastname: lastname,
                    phone: phone,
                  },
                ],
              },
              callback: function (response) {
                if (response.reference && response.status === 'success') {
                  const ref = response.reference

                  try {
                    axios.get(`${VERIFICATION_URL}${ref}`, {}).then((res) => {
                      if (res.data.data.status === 'success' && res.data.data.domain === 'live') {
                        toast.success('Transaction successful')
                        // setTimeout(() => {
                        //   history.push({
                        //     pathname: '/scheduler',
                        //     state: {
                        //       detail: newuser,
                        //       user_id: userid,
                        //       zone_id: zoneid,
                        //       address: address,
                        //       reference: ref,
                        //       category: 3,
                        //     },
                        //   })
                        // })
                      } else {
                        toast.info('Something went wrong!')
                      }
                    })
                  } catch (e) {
                    toast.info('Something went wrong!')
                  }
                } else {
                  toast.info('Transaction Failed')
                }
              },
              onClose: function () {
                //            alert('window closed');
              },
            })
            ResidentialProHandler.openIframe()
          } else if (state === 'Abuja' || state === 'Lagos' || state === 'Rivers') {
            //   try{
            let ResidentialProHandler
            ResidentialProHandler = window.PaystackPop.setup({
              key: `${PAYSTACK_PUBLIC_KEY}`,
              email: email,
              amount: 28500000,
              ref: '' + generated_reference, // generates a pseudo-unique reference. Please replace with a reference you generated. Or remove the line entirely so our API will generate one for you
              firstname: firstName,
              lastname: lastname,
              // label: "Optional string that replaces user email"
              metadata: {
                custom_fields: [
                  {
                    email: email,
                    amount: 285000,
                    state: state,
                    payment_type: 'installation',
                    month: '6',
                    firstname: firstName,
                    lastname: lastname,
                    phone: phone,
                  },
                ],
              },
              callback: function (response) {
                if (response.reference && response.status === 'success') {
                  const ref = response.reference

                  try {
                    axios.get(`${VERIFICATION_URL}${ref}`, {}).then((res) => {
                      if (res.data.data.status === 'success' && res.data.data.domain === 'live') {
                        toast.success('Transaction successful')
                        // setTimeout(() => {
                        //   history.push({
                        //     pathname: '/scheduler',
                        //     state: {
                        //       detail: newuser,
                        //       user_id: userid,
                        //       zone_id: zoneid,
                        //       address: address,
                        //       reference: ref,
                        //       category: 3,
                        //     },
                        //   })
                        // })
                      } else {
                        toast.info('Something went wrong!')
                      }
                    })
                  } catch (e) {
                    toast.info('Something went wrong!')
                  }
                } else {
                  toast.info('Transaction Failed')
                }
              },
              onClose: function () {
                //            alert('window closed');
              },
            })
            ResidentialProHandler.openIframe()
          } else if (
            state === 'Sokoto' ||
            state === 'Kebbi' ||
            state === 'Zamfara' ||
            state === 'Niger' ||
            state === 'Kwara' ||
            state === 'Osun' ||
            state === 'Ekiti' ||
            state === 'Ondo' ||
            state === 'Kogi' ||
            state === 'Bayelsa' ||
            state === 'Katsina' ||
            state === 'Bauchi' ||
            state === 'Nasarawa' ||
            state === 'Benue' ||
            state === 'Ebonyi' ||
            state === 'Jigawa' ||
            state === 'Yobe' ||
            state === 'Borno' ||
            state === 'Gombe' ||
            state === 'Adamawa' ||
            state === 'Plateau' ||
            state === 'Taraba'
          ) {
            let ResidentialProHandler
            ResidentialProHandler = window.PaystackPop.setup({
              key: `${PAYSTACK_PUBLIC_KEY}`,
              email: email,
              amount: 30000000,
              ref: '' + generated_reference, // generates a pseudo-unique reference. Please replace with a reference you generated. Or remove the line entirely so our API will generate one for you
              firstname: firstName,
              lastname: lastname,
              // label: "Optional string that replaces user email"
              metadata: {
                custom_fields: [
                  {
                    email: email,
                    amount: 300000,
                    state: state,
                    payment_type: 'installation',
                    month: '6',
                    firstname: firstName,
                    lastname: lastname,
                    phone: phone,
                  },
                ],
              },
              callback: function (response) {
                if (response.reference && response.status === 'success') {
                  const ref = response.reference

                  try {
                    axios.get(`${VERIFICATION_URL}${ref}`, {}).then((res) => {
                      if (res.data.data.status === 'success' && res.data.data.domain === 'live') {
                        toast.success('Transaction successful')
                        // setTimeout(() => {
                        //   history.push({
                        //     pathname: '/scheduler',
                        //     state: {
                        //       detail: newuser,
                        //       user_id: userid,
                        //       zone_id: zoneid,
                        //       address: address,
                        //       reference: ref,
                        //       category: 3,
                        //     },
                        //   })
                        // })
                      } else {
                        toast.info('Something went wrong!')
                      }
                    })
                  } catch (e) {
                    toast.info('Something went wrong!')
                  }
                } else {
                  toast.info('Transaction Failed')
                }
              },
              onClose: function () {
                //            alert('window closed');
              },
            })
            ResidentialProHandler.openIframe()
          }
          break

        case 210000:
          if (
            state === 'Abia' ||
            state === 'Kano' ||
            state === 'Delta' ||
            state === 'Akwa-ibom' ||
            state === 'Anambra' ||
            state === 'Kaduna' ||
            state === 'Imo' ||
            state === 'Enugu' ||
            state === 'Cross river' ||
            state === 'Oyo' ||
            state === 'Ogun' ||
            state === 'Edo'
          ) {
            //   try{
            let ResidentialYearlyhandler
            ResidentialYearlyhandler = window.PaystackPop.setup({
              key: `${PAYSTACK_PUBLIC_KEY}`,
              email: email,
              amount: 36000000,
              ref: '' + generated_reference, // generates a pseudo-unique reference. Please replace with a reference you generated. Or remove the line entirely so our API will generate one for you
              firstname: firstName,
              lastname: lastname,
              // label: "Optional string that replaces user email"
              metadata: {
                custom_fields: [
                  {
                    email: email,
                    amount: 360000,
                    state: state,
                    payment_type: 'installation',
                    month: '12',
                    firstname: firstName,
                    lastname: lastname,
                    phone: phone,
                  },
                ],
              },
              callback: function (response) {
                if (response.reference && response.status === 'success') {
                  const ref = response.reference

                  try {
                    axios.get(`${VERIFICATION_URL}${ref}`, {}).then((res) => {
                      if (res.data.data.status === 'success' && res.data.data.domain === 'live') {
                        toast.success('Transaction successful')
                        // setTimeout(() => {
                        //   history.push({
                        //     pathname: '/scheduler',
                        //     state: {
                        //       detail: newuser,
                        //       user_id: userid,
                        //       zone_id: zoneid,
                        //       address: address,
                        //       reference: ref,
                        //       category: 4,
                        //     },
                        //   })
                        // })
                      } else {
                        toast.info('Something went wrong!')
                      }
                    })
                  } catch (e) {
                    toast.info('Something went wrong!')
                  }
                } else {
                  toast.info('Transaction Failed')
                }
              },
              onClose: function () {
                //            alert('window closed');
              },
            })
            ResidentialYearlyhandler.openIframe()
          } else if (state === 'Abuja' || state === 'Lagos' || state === 'Rivers') {
            //   try{
            let ResidentialYearlyhandler
            ResidentialYearlyhandler = window.PaystackPop.setup({
              key: `${PAYSTACK_PUBLIC_KEY}`,
              email: email,
              amount: 42000000,
              ref: '' + generated_reference, // generates a pseudo-unique reference. Please replace with a reference you generated. Or remove the line entirely so our API will generate one for you
              firstname: firstName,
              lastname: lastname,
              // label: "Optional string that replaces user email"
              metadata: {
                custom_fields: [
                  {
                    email: email,
                    amount: 420000,
                    state: state,
                    payment_type: 'installation',
                    month: '12',
                    firstname: firstName,
                    lastname: lastname,
                    phone: phone,
                  },
                ],
              },
              callback: function (response) {
                if (response.reference && response.status === 'success') {
                  const ref = response.reference

                  try {
                    axios.get(`${VERIFICATION_URL}${ref}`, {}).then((res) => {
                      if (res.data.data.status === 'success' && res.data.data.domain === 'live') {
                        toast.success('Transaction successful')
                        // setTimeout(() => {
                        //   history.push({
                        //     pathname: '/scheduler',
                        //     state: {
                        //       detail: newuser,
                        //       user_id: userid,
                        //       zone_id: zoneid,
                        //       address: address,
                        //       reference: ref,
                        //       category: 4,
                        //     },
                        //   })
                        // })
                      } else {
                        toast.info('Something went wrong!')
                      }
                    })
                  } catch (e) {
                    toast.info('Something went wrong!')
                  }
                } else {
                  toast.info('Transaction Failed')
                }
              },
              onClose: function () {
                //            alert('window closed');
              },
            })
            ResidentialYearlyhandler.openIframe()
          } else if (
            state === 'Sokoto' ||
            state === 'Kebbi' ||
            state === 'Zamfara' ||
            state === 'Niger' ||
            state === 'Kwara' ||
            state === 'Osun' ||
            state === 'Ekiti' ||
            state === 'Ondo' ||
            state === 'Kogi' ||
            state === 'Bayelsa' ||
            state === 'Katsina' ||
            state === 'Bauchi' ||
            state === 'Nasarawa' ||
            state === 'Benue' ||
            state === 'Ebonyi' ||
            state === 'Jigawa' ||
            state === 'Yobe' ||
            state === 'Borno' ||
            state === 'Gombe' ||
            state === 'Adamawa' ||
            state === 'Plateau' ||
            state === 'Taraba'
          ) {
            let ResidentialYearlyhandler
            ResidentialYearlyhandler = window.PaystackPop.setup({
              key: `${PAYSTACK_PUBLIC_KEY}`,
              email: email,
              amount: 45000000,
              ref: '' + generated_reference, // generates a pseudo-unique reference. Please replace with a reference you generated. Or remove the line entirely so our API will generate one for you
              firstname: firstName,
              lastname: lastname,
              // label: "Optional string that replaces user email"
              metadata: {
                custom_fields: [
                  {
                    email: email,
                    amount: 450000,
                    state: state,
                    payment_type: 'installation',
                    month: '12',
                    firstname: firstName,
                    lastname: lastname,
                    phone: phone,
                  },
                ],
              },
              callback: function (response) {
                if (response.reference && response.status === 'success') {
                  const ref = response.reference

                  try {
                    axios.get(`${VERIFICATION_URL}${ref}`, {}).then((res) => {
                      if (res.data.data.status === 'success' && res.data.data.domain === 'live') {
                        toast.success('Transaction successful')
                        // setTimeout(() => {
                        //   history.push({
                        //     pathname: '/scheduler',
                        //     state: {
                        //       detail: newuser,
                        //       user_id: userid,
                        //       zone_id: zoneid,
                        //       address: address,
                        //       reference: ref,
                        //       category: 4,
                        //     },
                        //   })
                        // })
                      } else {
                        toast.info('Something went wrong!')
                      }
                    })
                  } catch (e) {
                    toast.info('Something went wrong!')
                  }
                } else {
                  toast.info('Transaction Failed')
                }
              },
              onClose: function () {
                //            alert('window closed');
              },
            })
            ResidentialYearlyhandler.openIframe()
          }

          break

        case 60000:
          if (payment_option == 'aella') {
            try {
              const data = {
                action: 'generate_aella_setup_url',
                amount: 245000,
                email: email,
              }
              const options = {
                method: 'POST',
                headers: { 'content-type': 'application/x-www-form-urlencoded' },
                data: qs.stringify(data),
                url: `${GENIATECH_URL}`,
              }
              axios(options).then((response) => {
                if (response.data.status) {
                  let gen_url = response.data.url
                  window.location.href = gen_url
                } else {
                  toast.success('An error occured')
                }
              })
            } catch (err) {
              toast.info('Something went wrong!')
            }
          } else {
            let TurboConnecthandler
            TurboConnecthandler = window.PaystackPop.setup({
              key: `${PAYSTACK_PUBLIC_KEY}`,
              email: email,
              amount: 24500000,
              ref: '' + generated_reference, // generates a pseudo-unique reference. Please replace with a reference you generated. Or remove the line entirely so our API will generate one for you
              firstname: firstName,
              lastname: lastname,
              // label: "Optional string that replaces user email"
              metadata: {
                custom_fields: [
                  {
                    email: email,
                    amount: 19500000,
                    state: state,
                    payment_type: 'installation',
                    month: '1',
                    firstname: firstName,
                    lastname: lastname,
                    phone: phone,
                  },
                ],
              },
              callback: function (response) {
                if (response.reference && response.status === 'success') {
                  const ref = response.reference

                  try {
                    axios.get(`${VERIFICATION_URL}${ref}`, {}).then((res) => {
                      if (res.data.data.status === 'success' && res.data.data.domain === 'live') {
                        toast.success('Transaction successful')
                      } else {
                        toast.info('Something went wrong!')

                        // setTimeout(() => {
                        //   history.push({
                        //     pathname: '/scheduler',
                        //     state: {
                        //       detail: newuser,
                        //       user_id: userid,
                        //       zone_id: zoneid,
                        //       address: address,
                        //       reference: ref,
                        //       category: 1,
                        //     },
                        //   })
                        // })
                      }
                    })
                  } catch (e) {
                    toast.info('Something went wrong!')
                  }
                } else {
                  toast.info('Transaction Failed')
                }
              },
              onClose: function () {
                //            alert('window closed');
              },
            })
            TurboConnecthandler.openIframe()
          }

          break

        default:
          window.location.href = 'https://paystack.com/pay/2UY6v6TNW5'
      }

      toast.success('User registered')
      // Swal.fire({
      //   title: 'Successful!',
      //   text: 'We have recieved your information. A member of our team will contact you very soon! Thank you.',
      //   icon: 'success',
      //   confirmButtonColor: '#1ac9d8',
      // }).then(function () {
      //   window.location.replace('')
      // })
    }
  } catch (e) {
    if (e) {
      toast.error(e.response.data.message)

      dispatch({
        type: LOADING_STOPS,
        payload: false,
      })
    }
  }
}

const useCheckAvailableDates = () => {
  const [{ date_a, items, date_h, isLoading }, dispatch] = useReducer(scheduleReducer, {
    isLoading: false,
    items: [],
    date_a: null,
    date_h: null,
  })

  const getAvailableDates = async (datay) => {
    dispatch({ type: LOADING_STARTS })

    try {
      const res = await axios.post(`${CHECK_AVAILABLE_DATES_URL}`, datay)
      if (res.data) {
        console.log(res.data[0].date)

        dispatch({
          type: SCHEDULE_SUCCESS,
          payload: {
            items: res.data,
            date_a: res.data[0].date,
            date_h: res.data[4].date,
          },
        })
      }
    } catch (e) {
      toast.info('Something went wrong!')
      if (e.response) {
        dispatch({ type: LOADING_STOPS })
      }
    }
  }

  const getNextAvailableDates = async (nextdata) => {
    dispatch({ type: LOADING_STARTS })

    try {
      const res = await axios.post(`${CHECK_AVAILABLE_DATES_URL}`, nextdata)
      if (res.data) {
        console.log(res.data[0].date)

        dispatch({
          type: SCHEDULE_SUCCESS,
          payload: {
            items: res.data,
            date_a: res.data[0].date,
            date_h: res.data[4].date,
          },
        })
      }
    } catch (e) {
      toast.info('Something went wrong!')
      if (e.response) {
        dispatch({ type: LOADING_STOPS })
      }
    }
  }

  return {
    isLoading,
    getAvailableDates,
    date_a,
    getNextAvailableDates,
    items,
    date_h,
  }
}

export default useCheckAvailableDates
